import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { AppConfigProvider } from "@/context/AppConfigContext";
import AppLayout from "@/components/AppLayout";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Register from "@/pages/Register";
import Timeline from "@/pages/Timeline";
import PostDetail from "@/pages/PostDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Community from "@/pages/Community";
import Carteirinha from "@/pages/Carteirinha";
import Donations from "@/pages/Donations";
import Profile from "@/pages/Profile";
import Rights from "@/pages/Rights";
import RightDetail from "@/pages/RightDetail";
import DiagnosticGuide from "@/pages/DiagnosticGuide";
import DiagnosticTopicDetail from "@/pages/DiagnosticTopicDetail";
import Support from "@/pages/Support";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import CoursePlayer from "@/pages/CoursePlayer";
import Associate from "@/pages/Associate";
import Verify from "@/pages/Verify";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import { ProtectedRoute } from "@/components/ProtectedRoute";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppConfigProvider>
          <CartProvider>
            <BrowserRouter>
          <Routes>
            <Route element={<AppLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/entrar" element={<Login />} />
              <Route path="/esqueci-senha" element={<ForgotPassword />} />
              <Route path="/redefinir-senha" element={<ResetPassword />} />
              <Route path="/cadastro" element={<Register />} />
              <Route path="/timeline" element={<Timeline />} />
              <Route path="/postagem/:id" element={<PostDetail />} />
              <Route path="/sobre" element={<About />} />
              <Route path="/contato" element={<Contact />} />
              <Route path="/doacoes" element={<Donations />} />
              <Route path="/doacoes/sucesso" element={<Donations />} />
              <Route path="/comunidade" element={<Community />} />
              <Route path="/direitos" element={<Rights />} />
              <Route path="/direitos/:slug" element={<RightDetail />} />
              <Route path="/guia-do-diagnostico" element={<DiagnosticGuide />} />
              <Route path="/guia-do-diagnostico/:slug" element={<DiagnosticTopicDetail />} />
              <Route path="/apoiar" element={<Support />} />
              <Route path="/verificar/:kind/:code" element={<Verify />} />
              <Route path="/cursos" element={<Courses />} />
              <Route path="/cursos/:slug" element={<CourseDetail />} />
              <Route path="/produtos" element={<Products />} />
              <Route path="/produtos/:slug" element={<ProductDetail />} />
              <Route path="/carrinho" element={<Cart />} />
              <Route path="/loja/sucesso" element={<CheckoutSuccess />} />
              <Route
                path="/cursos/:slug/aula/:moduleId"
                element={
                  <ProtectedRoute>
                    <CoursePlayer />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/associado"
                element={
                  <ProtectedRoute>
                    <Associate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/associado/certificados"
                element={
                  <ProtectedRoute>
                    <Associate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/carteirinha"
                element={
                  <ProtectedRoute>
                    <Carteirinha />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/perfil"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Route>
            </Routes>
          </BrowserRouter>
          </CartProvider>
        </AppConfigProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
